type PropTypes = {
  className?: string
}

const EdgeArrow = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="6"
      fill="none"
      className={className}
    >
      <path
        fill="#D9D9D9"
        stroke="#000"
        d="M1.782 5.5 4 1.109 6.218 5.5H1.782Z"
      />
    </svg>
  )
}

export default EdgeArrow
